import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import Checkbox from 'ext-ui/components/Checkbox/Checkbox'
import React from 'react'
import { useSelector } from 'react-redux'
import BottomBox from 'src/components/BottomBox/BottomBox'
import TestId from 'src/components/TestId/TestId'
import Crncy from 'src/localization/Crncy'
import { useTranslate } from 'src/localization/Trns'
import { selectUserListModelFromState } from 'src/redux/selectors/auth.selectors'
import { selectDefaultCurrencyFromState } from 'src/redux/selectors/session.selectors'
import { toDollars } from 'src/utils/currency.utils'
import { css } from 'styled-components'

interface ReceiptsRequiredBoxProps {
  className?: string
  receiptRulesExempt?: boolean
  onChange: (val: boolean) => void
  virtualCardCurrency?: string
  receiptThresholdCents?: number
  showNote?: boolean
}

export const ReceiptsRequiredBox: React.FC<ReceiptsRequiredBoxProps> = (
  props,
): React.ReactElement => {
  const user = useSelector(selectUserListModelFromState)
  const defaultCurrency = useSelector(selectDefaultCurrencyFromState)
  const translate = useTranslate()

  return (
    <BottomBox
      className={props.className}
      label={translate('Receipt Rules')}
      collapsible
      css={css`
        display: flex;
        flex-direction: column;
      `}
    >
      <div
        css={css`
          ${getFontCss(
            14,
            styleConstants.colors.gray_darkest,
            styleConstants.fontFamilies.regular,
          )};
        `}
      >
        {translate(
          'If enabled, receipts will be required for transactions over ${limit} on this card.',
          {
            limit: (
              <Crncy
                currency={
                  props.virtualCardCurrency || user?.currency || defaultCurrency
                }
                amount={toDollars(props.receiptThresholdCents ?? 0)}
                maximumFractionDigits={2}
              />
            ),
          },
        )}
      </div>
      {props.showNote && (
        <div
          css={css`
            ${getFontCss(
              14,
              styleConstants.colors.gray_darkest,
              styleConstants.fontFamilies.regular,
            )};
          `}
        >
          {translate(
            'Enabling or disabling will apply to all previous transactions.',
          )}
        </div>
      )}
      <TestId testId={'receiptRulesCheckbox'}>
        <div
          className="flex-row align-center gap-2"
          // AI tried to use mt-6 for this value but it does not exist
          // Reverting to regular old css here
          css={css`
            margin-top: 24px;
          `}
        >
          <Checkbox
            id="receipt-rules-checkbox"
            checked={!props.receiptRulesExempt}
            onChange={(): void => {
              props.onChange(!props.receiptRulesExempt)
            }}
            aria-label={translate('Enable receipt rules for this card')}
          />
          <label
            htmlFor="receipt-rules-checkbox"
            css={css`
              ${getFontCss(
                14,
                themeConstants.colors.font_primary,
                styleConstants.fontFamilies.regular,
              )};
              cursor: pointer;
            `}
          >
            {translate('Enable receipt rules for this card')}
          </label>
        </div>
      </TestId>
    </BottomBox>
  )
}

export default ReceiptsRequiredBox
